<template>
    <div class="pedigree-horse flex w-full align-items-center" :style="height">
        <div v-if="editable && !first" class="horse-editable-information" :class="first ? 'font-bold' : ''" :style="height">
            <CustomAutocompleteHorse name="pedigreeHorse" v-model="horse" :horse-sex="horseSex"/>
            <div v-if="editable">
                <CustomIconButton v-if="onlyIconAddButton" icon="pi pi-plus" onlyIcon @click="newHorseDialog = true"
                                  class="close-form-button" />
                <div v-else class="ml-3">
                    <CustomTextButton :label="$t('message.horseEdit.main.pedigree.addNewHorseButton')"
                                      @click="newHorseDialog = true" class="w-full"/>
                </div>
                <CheckIfHorseExistDialog v-model="showExistingHorsesDialog" :similarHorses="similarHorses"
                                         @useHorse="useHorse" pedigree :horseSex="horseSex" />
                <Dialog v-model:visible="newHorseDialog" :header="$t('message.horseEdit.main.pedigree.addNewHorseHeader')"
                        modal :closable="true">
                    <PedigreeAddHorseForm :horseSex="horseSex" @addHorse="handleNewHorse" @showExistDialog="showExistDialog"/>
                </Dialog>
            </div>
        </div>
        <div v-else class="horse-information" :class="first ? 'font-bold' : ''" :style="height">
            {{horseInformation}}
        </div>

        <div v-if="horse != null && depthLasts > 0" class="flex align-items-center h-full" :style="height">
            <div class="child-line"/>
            <div class="parents-lines">
                <div class="parent-line"/>
                <div class="parent-line"/>
            </div>
            <div class="flex flex-column h-full">
                <PedigreeHorse v-model="horse.father" :depthLasts="depthLasts - 1" :editable="editable"
                               :onlyIconAddButton="onlyIconAddButton" horseSex="STALLION"/>
                <PedigreeHorse v-model="horse.mother" :depthLasts="depthLasts - 1" :editable="editable"
                               :onlyIconAddButton="onlyIconAddButton" horseSex="BROODMARE"/>
            </div>
        </div>
    </div>
</template>

<script>
import Dialog from "primevue/dialog";
import CustomAutocompleteHorse from "@/components/form/CustomAutocompleteHorse.vue";
import CustomAutocompleteUser from "@/components/form/CustomAutocompleteUser.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import PedigreeAddHorseForm from "@/views/horse/horseEdit/main/components/PedigreeAddHorseForm.vue";
import CheckIfHorseExistDialog from "@/components/CheckIfHorseExistDialog.vue";

export default {
    name: "PedigreeHorse",
    components: {
        PedigreeAddHorseForm,
        CustomTextButton,
        CustomIconButton,
        CustomAutocompleteUser,
        CustomAutocompleteHorse,
        Dialog,
        CheckIfHorseExistDialog,
    },

    props: {
        depthLasts: {
            type: Number,
            default: 0,
        },
        modelValue: {
            required: true,
        },
        first: {
            type: Boolean,
            default: false,
        },
        horseSex: null,
        editable: {
            type: Boolean,
            default: false,
        },
        onlyIconAddButton: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue"],

    data() {
        return {
            newHorseDialog: false,
            showExistingHorsesDialog: false,
            similarHorses: [],
        };
    },

    mounted() {
        const elements = document.querySelectorAll(".section-details .horse-preview .horse-information");
        let maxWidth = 0;
        elements.forEach((el) => {
            const width = el.offsetWidth;
            if (width > maxWidth) maxWidth = width;
        });

        elements.forEach((el) => {
            el.style.width = `${maxWidth}px`;
        });
    },

    computed: {
        horse: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
        birthYear() {
            if (this.horse == null || this.horse.dateOfBirth == null) return null;

            const parts = this.horse.dateOfBirth.split("-");
            if (parts.length !== 3) return null;

            const year = parts[2];
            return parseInt(year);
        },
        horseInformation() {
            if (this.horse == null) return "?";
            let result = this.horse.fullNameWithCountryCode ? this.horse.fullNameWithCountryCode : this.horse.name;
            if (this.birthYear != null) result = result + ", " + this.birthYear;
            if (this.horse.color != null) result = result + ", " + this.horse.color;
            return result;
        },
        height() {
            const SINGLE_HORSE_HEIGHT = this.editable ? 50 : 30;
            const value = 2 ** this.depthLasts * SINGLE_HORSE_HEIGHT;
            return "height: " + value + "px;";
        },
    },
    methods: {
        handleNewHorse(newHorse) {
            this.horse = newHorse;
            this.newHorseDialog = false;
        },
        showExistDialog(value) {
            this.similarHorses = value;
            this.showExistingHorsesDialog = true;
        },
        useHorse(value) {
            this.horse = value;
            this.showExistingHorsesDialog = false;
            this.newHorseDialog = false;
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.pedigree-horse {
    font-family: var(--decor-font-family);
    font-size: 20px;
    min-width: max-content;

    // .graph {
    //     min-width: max-content;
    // }

    .horse-information {
        width: max-content;
        display: flex;
        padding: 0 0.5rem;
        align-items: center;
    }

    .horse-editable-information {
        display: flex;
        padding: 0 0.5rem;
        align-items: center;
    }

    .child-line, .parent-line {
        height: 1px;
        background-color: var(--text-color);
        width: 30px;
    }

    .parents-lines {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-left: 1px solid var(--text-color);
        height: 50%;
    }

    .p-autocomplete .p-button {
        background: none;
        color: var(--primary-color);
        border-left: none;
    }
}
</style>
